/**
 * @generated SignedSource<<a4a3d90a0acca8b7160b8c07f85b1a0c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

const node = function () {
  var v0 = [{
    "alias": null,
    "args": null,
    "concreteType": "CurrentUserContext",
    "kind": "LinkedField",
    "name": "currentUserContext",
    "plural": false,
    "selections": [{
      "alias": null,
      "args": null,
      "concreteType": "ReverseUidSimplenewsSubscriber",
      "kind": "LinkedField",
      "name": "reverseUidSimplenewsSubscriber",
      "plural": false,
      "selections": [{
        "alias": null,
        "args": null,
        "concreteType": "SimplenewsSubscriber",
        "kind": "LinkedField",
        "name": "entities",
        "plural": true,
        "selections": [{
          "alias": null,
          "args": null,
          "concreteType": "SimplenewsSubscriberSubscription",
          "kind": "LinkedField",
          "name": "subscriptions",
          "plural": true,
          "selections": [{
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          }, {
            "alias": null,
            "args": null,
            "concreteType": "SimplenewsSubscriberSubscriptionEntity",
            "kind": "LinkedField",
            "name": "entity",
            "plural": false,
            "selections": [{
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "entityId",
              "storageKey": null
            }],
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }],
    "storageKey": null
  }];
  return {
    "fragment": {
      "argumentDefinitions": [],
      "kind": "Fragment",
      "metadata": null,
      "name": "apisSignupNewsletterQuery",
      "selections": v0 /*: any*/,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [],
      "kind": "Operation",
      "name": "apisSignupNewsletterQuery",
      "selections": v0 /*: any*/
    },
    "params": {
      "cacheID": "bee14d13a84d3a7ae570d06e18ab0d29",
      "id": null,
      "metadata": {},
      "name": "apisSignupNewsletterQuery",
      "operationKind": "query",
      "text": "query apisSignupNewsletterQuery {\n  currentUserContext {\n    reverseUidSimplenewsSubscriber {\n      entities {\n        subscriptions {\n          status\n          entity {\n            entityId\n          }\n        }\n      }\n    }\n  }\n}\n"
    }
  };
}();
node.hash = "9ef62adb5a9764d0efceaca536e80013";
export default node;